export enum OrderAccessInviteStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
}

export enum OrderAccessRole {
  VIEWER = 'VIEWER',
  MANAGER = 'MANAGER',
}

export enum OrderAccessStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum ROLE_LABEL {
  VIEWER = 'Viewer',
  MANAGER = 'Editor',
  GROUP_CUSTOM_OFFER_VIEWER = 'Viewer',
}

export type OrderAccessOption = {
  value: OrderAccessRole
  description: string
}

export type SuggestedTraveller = {
  name: string
  email: string
}
